import type { Config } from "../types";

interface ApiConfig {
  apiRoot: string;
  webClientId: string;
  appClientId: string;
  redirectState: string;
  redirectUri: string;
  webRedirectUri: string;
  redirectUriLogin: string;
  responseType: string;
}

export type RedirectParameters = Omit<
  ApiConfig,
  "apiRoot" | "webClientId" | "webRedirectUri"
>;

let apiConfig: Readonly<ApiConfig>;

export function setApiConfig(config: Config, values: RedirectParameters) {
  apiConfig = Object.freeze({
    apiRoot: config.core_api_host + "/" + config.core_api_version,
    webClientId: config.oauth_default_client_id,
    appClientId: values.appClientId,
    redirectState: values.redirectState,
    redirectUri: values.redirectUri,
    webRedirectUri: config.oauth_default_redirect_uri,
    redirectUriLogin: values.redirectUriLogin,
    responseType: values.responseType,
  });
}

export function getApiRoot() {
  return apiConfig.apiRoot;
}

export function getWebClientId() {
  return apiConfig.webClientId;
}

export function getAppClientId() {
  return apiConfig.appClientId;
}

export function getRedirectState() {
  return apiConfig.redirectState;
}

export function getRedirectUri() {
  return apiConfig.redirectUri;
}

function getResponseType() {
  return apiConfig.responseType;
}

export const getIsAuthCodeRequested = (): boolean =>
  getResponseType() === "code" || getRedirectUri().startsWith("kivra://");

export const getIsWeb = (): boolean => apiConfig.redirectUri.startsWith("http");

export const getRedirectParameters = (): RedirectParameters => ({
  appClientId: apiConfig.appClientId,
  redirectState: apiConfig.redirectState,
  redirectUri: apiConfig.redirectUri,
  redirectUriLogin: apiConfig.redirectUriLogin,
  responseType: apiConfig.responseType,
});
